import useTranslation from '@space-core/hooks/useTranslation'

export type EmptyStateTypes = 'USER_NOT_FIND' | 'EMPTY_BAN_LIST' | 'ERROR_LOAD_LIST' | null

export type EmptyStateUnBanMemberProps = {
  type?: EmptyStateTypes
}

const EmptyStateUnBanMember = ({ type }: EmptyStateUnBanMemberProps) => {
  const { t } = useTranslation()

  if (!type) {
    return null
  }

  const emptyStateTypes = {
    USER_NOT_FIND: t('modal.ban_list.empty_state.user_not_find'),
    EMPTY_BAN_LIST: t('modal.ban_list.empty_state.empty_ban_list'),
    ERROR_LOAD_LIST: t('modal.ban_list.empty_state.error_load_list')
  }

  const messageEmptyState = type && emptyStateTypes[type]

  return (
    <div className='_d-flex _align-items-center _justify-content-center _w-full'>
      <p className='_text-gray-500 _text-2 _text-center'>{messageEmptyState}</p>
    </div>
  )
}

export default EmptyStateUnBanMember
